import React from "react";

export const DEFAULT_FILTERS = {
  action: "",
  userId: "",
  bookingId: "",
  ip: "",
  path: "",
  q: "",
  fromDate: "",
  toDate: "",
  limit: 20,
};

function LogFilters({ filters, loading, onFilterChange, onApplyFilters, onClearFilters }) {
  return (
    <div className="card mb-4 border-0 shadow-sm">
      <div className="card-body">
        <form onSubmit={onApplyFilters}>
          <div className="row g-2 align-items-end">
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
              <label className="form-label small fw-semibold" htmlFor="action">
                Action
              </label>
              <input
                id="action"
                name="action"
                type="text"
                className="form-control form-control-sm"
                value={filters.action}
                onChange={onFilterChange}
                placeholder="e.g. FULL_CANCELLATION"
              />
            </div>

            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
              <label className="form-label small fw-semibold" htmlFor="userId">
                User ID
              </label>
              <input
                id="userId"
                name="userId"
                type="text"
                className="form-control form-control-sm"
                value={filters.userId}
                onChange={onFilterChange}
                placeholder="e.g. 123"
              />
            </div>

            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
              <label className="form-label small fw-semibold" htmlFor="bookingId">
                Booking ID
              </label>
              <input
                id="bookingId"
                name="bookingId"
                type="text"
                className="form-control form-control-sm"
                value={filters.bookingId}
                onChange={onFilterChange}
                placeholder="e.g. 67544"
              />
            </div>

            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
              <label className="form-label small fw-semibold" htmlFor="q">
                Search Query (Browser)
              </label>
              <input
                id="q"
                name="q"
                type="text"
                className="form-control form-control-sm"
                value={filters.q}
                onChange={onFilterChange}
                placeholder="e.g. Chrome, Windows"
              />
            </div>

            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
              <label className="form-label small fw-semibold" htmlFor="fromDate">
                From Date
              </label>
              <input
                id="fromDate"
                name="fromDate"
                type="date"
                className="form-control form-control-sm"
                value={filters.fromDate}
                onChange={onFilterChange}
              />
            </div>

            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
              <label className="form-label small fw-semibold" htmlFor="toDate">
                To Date
              </label>
              <input
                id="toDate"
                name="toDate"
                type="date"
                className="form-control form-control-sm"
                value={filters.toDate}
                onChange={onFilterChange}
              />
            </div>

            <div className="col-xl-1 col-lg-2 col-md-4 col-sm-6">
              <label className="form-label small fw-semibold" htmlFor="limit">
                Limit
              </label>
              <select
                id="limit"
                name="limit"
                className="form-select form-select-sm"
                value={filters.limit}
                onChange={onFilterChange}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-8 col-12">
              <div className="d-flex gap-2">
                <button
                  type="submit"
                  className="btn btn-sm btn-primary d-flex align-items-center gap-1 flex-fill justify-content-center"
                  disabled={loading}
                >
                  <i className="bi bi-funnel"></i> Apply
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1 flex-fill justify-content-center"
                  onClick={onClearFilters}
                  disabled={loading}
                >
                  <i className="bi bi-arrow-counterclockwise"></i> Clear
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LogFilters;
